import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/core/services/toast.service';
import { environment } from 'src/environments/environment';

interface Faq {
  id: number;
  question: string;
  reponse: string;
}

@Component({
  selector: 'app-gestion-faq',
  templateUrl: './gestion-faq.component.html',
  styleUrls: ['./gestion-faq.component.scss']
})
export class GestionFaqComponent implements OnInit {
  faqs: Faq[] = [];
  faqsFiltrees: Faq[] = [];
  recherche = '';
  chargement = false;
  sauvegardeEnCours = false;
  afficherModal = false;
  modeEdition = false;
  idEdition: number | null = null;
  faqOuverte: number | null = null;

  formulaire: Partial<Faq> = { question: '', reponse: '' };

  private readonly apiUrl = `${environment.loginurl}faq`;

  constructor(private http: HttpClient, private toast: ToastService) {}

  ngOnInit(): void { this.charger(); }

  charger(): void {
    this.chargement = true;
    this.http.get<Faq[]>(this.apiUrl).subscribe({
      next: (data) => {
        this.faqs = Array.isArray(data) ? data : [];
        this.appliquerFiltre();
        this.chargement = false;
      },
      error: () => { this.chargement = false; this.toast.erreur('Impossible de charger la FAQ'); }
    });
  }

  appliquerFiltre(): void {
    const q = this.recherche.toLowerCase().trim();
    this.faqsFiltrees = q
      ? this.faqs.filter(f => f.question.toLowerCase().includes(q) || f.reponse.toLowerCase().includes(q))
      : [...this.faqs];
  }

  toggleAccordion(id: number): void {
    this.faqOuverte = this.faqOuverte === id ? null : id;
  }

  ouvrirCreation(): void {
    this.modeEdition = false; this.idEdition = null;
    this.formulaire = { question: '', reponse: '' };
    this.afficherModal = true;
  }

  ouvrirEdition(f: Faq): void {
    this.modeEdition = true; this.idEdition = f.id;
    this.formulaire = { question: f.question, reponse: f.reponse };
    this.afficherModal = true;
  }

  fermerModal(): void { this.afficherModal = false; }

  sauvegarder(): void {
    if (!this.formulaire.question?.trim()) { this.toast.erreur('La question est obligatoire'); return; }
    if (!this.formulaire.reponse?.trim())  { this.toast.erreur('La réponse est obligatoire'); return; }
    this.sauvegardeEnCours = true;
    const req$ = this.modeEdition
      ? this.http.put<Faq>(`${this.apiUrl}/${this.idEdition}`, this.formulaire)
      : this.http.post<Faq>(this.apiUrl, this.formulaire);
    req$.subscribe({
      next: () => {
        this.toast.succes(this.modeEdition ? 'FAQ mise à jour' : 'FAQ ajoutée');
        this.fermerModal(); this.charger(); this.sauvegardeEnCours = false;
      },
      error: () => { this.toast.erreur('Erreur lors de l\'enregistrement'); this.sauvegardeEnCours = false; }
    });
  }

  supprimer(f: Faq): void {
    if (!confirm(`Supprimer cette question FAQ ?`)) return;
    this.http.delete(`${this.apiUrl}/${f.id}`).subscribe({
      next: () => { this.toast.succes('FAQ supprimée'); this.charger(); },
      error: () => this.toast.erreur('Impossible de supprimer cette entrée')
    });
  }
}
